import React from 'react'

export function IconErrorXSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50" fill="none">
      <g clipPath="url(#clip0_5787_32880)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6587 7.72912C15.2449 7.26039 15.9803 7.0186 16.7303 7.04806C17.4802 7.07752 18.1945 7.37627 18.742 7.88954C21.664 10.627 24.5015 13.4533 27.2504 16.3645C29.3382 13.8444 31.3631 11.2727 33.3233 8.65204C34.5545 7.00621 37.0275 6.96454 38.3025 8.60204L42.0837 13.4666C43.0004 14.6458 42.9608 16.325 41.9545 17.4562C39.6682 20.0109 37.2751 22.4679 34.7816 24.8208C37.2708 27.7855 39.6739 30.8215 41.9879 33.925C43.0608 35.3645 42.6962 37.4 41.215 38.3875L38.442 40.2375C37.8253 40.648 37.083 40.8264 36.3471 40.7409C35.6112 40.6555 34.9295 40.3117 34.4233 39.7708C31.9242 37.1034 29.3496 34.5079 26.7025 31.9875C23.1733 34.9458 19.5566 37.8041 15.9275 40.6458C15.5786 40.9185 15.1758 41.1139 14.7458 41.2191C14.3157 41.3244 13.8682 41.3371 13.4329 41.2563C12.9976 41.1755 12.5844 41.0032 12.2207 40.7507C11.857 40.4982 11.5511 40.1713 11.3233 39.7916L10.1525 37.8458C9.7846 37.2322 9.63813 36.511 9.73745 35.8025C9.83678 35.094 10.1759 34.4409 10.6983 33.952C13.6682 31.1715 16.5488 28.2971 19.3358 25.3333C16.0274 22.4986 12.6255 19.7749 9.13579 17.1666C8.75278 16.8804 8.4404 16.5103 8.22261 16.0846C8.00482 15.659 7.88739 15.1891 7.87935 14.711C7.8713 14.233 7.97285 13.7594 8.1762 13.3266C8.37955 12.8939 8.67929 12.5135 9.05246 12.2145L14.6587 7.72912Z"
          fill="#E02424"
        />
      </g>
      <defs>
        <clipPath id="clip0_5787_32880">
          <rect width="50" height="50" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  )
}
